import { makeAutoObservable } from 'mobx';
import Shape from '../interfaces/Shape';

export default class MapShapeStore {
    popupShapes: Shape[] = [];
    detailsShapes: Shape[] = [];
    lock: string = "";

    constructor() {
        makeAutoObservable(this);
    }

    draw(popup: Shape[], details: Shape[], lock: string) {
        this.popupShapes = popup;
        this.detailsShapes = details;
        this.lock = lock;
    }

    clearPopup(lock: string) {
        if (this.lock !== lock)
            return;

        this.popupShapes = [];
        if (!this.detailsShapes.length)
            this.lock = "";
    }

    clearDetails(lock: string) {
        if (this.lock !== lock)
            return;

        this.detailsShapes = [];
        if (!this.popupShapes.length)
            this.lock = "";
    }

    clear() {
        this.popupShapes = [];
        this.detailsShapes = [];
        this.lock = "";
    }
}
